import type { FormIssue } from '@app/shared';
import type { Dictionary } from '../i18n';
import { formatLimitSeconds, formatSeconds } from './format';

/** One line of «Что мешает утвердить»; `position` turns a block id into its 1-based number. */
export function issueText(issue: FormIssue, t: Dictionary, position: (blockId: string) => number): string {
  const s = t.issues;
  switch (issue.code) {
    case 'empty_block':
      return s.emptyBlock(position(issue.blockId));
    case 'block_too_long':
      return s.blockTooLong(position(issue.blockId), issue.actual, issue.max);
    case 'title_too_long':
      return s.titleTooLong(position(issue.blockId), issue.actual, issue.max);
    case 'title_not_allowed':
      return s.titleNotAllowed(position(issue.blockId));
    case 'no_letters':
      return s.noLetters(position(issue.blockId));
    case 'too_few_blocks':
      return s.tooFew(issue.min, issue.actual);
    case 'too_many_blocks':
      return s.tooMany(issue.max, issue.actual);
    case 'bad_roles':
      return s.badRoles;
    case 'reel_too_long':
      return s.reelTooLong(formatSeconds(issue.estimatedS), formatLimitSeconds(issue.maxS));
  }
}
